
import React from 'react';
import { EnhancedCrawlResult } from '@/types/crawler';
import OverviewPanel from '@/components/dashboard/overview/OverviewPanel';

interface OverviewContainerProps {
  crawlResult: EnhancedCrawlResult;
  onSelectPage?: (url: string) => void;
}

const OverviewContainer: React.FC<OverviewContainerProps> = ({
  crawlResult,
  onSelectPage
}) => {
  return (
    <div className="w-full" data-testid="overview-panel-wrapper">
      <OverviewPanel 
        crawlResult={crawlResult} 
        onSelectPage={onSelectPage} 
        data-testid="overview-panel"
      />
      {/* No additional components that might render "Top Performing Pages" */}
    </div>
  );
};

export default OverviewContainer;
